export const featureFlags = [
  'withAdminPanel',
  'withCsvFilePreviewLongCellImprovements',
  'withDashboardsExportableToOtherProjects',
  'withMarkdownWidgetsDashboard',
  'withStringSeriesPreviewDownload',
  'withFloatSeriesTextPreview',
  'withMetricAggregatesHidden',
  'withImprovedImageScalingAlgorithm',
  'withShortenedMetrics',
  'withNewLegendPositioning',
  'withMyRuns',
  'withEmaSmoothing',
  'withGaussianSmoothing',
  'withChemicalFilesPreview',
  'withInitiatives',
  'withDoubleClickZoomOut',
  'withNonFiniteValues',
  'withUdfWidget',
  'withReportDslEditor',
  'withWidgetDslEditor',
  'withImprovedTooltipEditing',
  'withAssociatedRunsOption',
  'withScreenshotLegend',
  'withDashboardLock',
  'withNewChartAllowed',
  'withNewChart',
  'withPulseCheckSurvey',
  'withTristateSelection',
  'withRunColorLists',
  'withVegaLiteWidgets',
  'withSlackShare',
] as const;
export type FeatureFlag = (typeof featureFlags)[number];

export type FeatureFlagConfig = `${FeatureFlag}Config`;

export const DB_PERSISTED_FEATURE_FLAGS_KEYS = [
  'withNewLegendPositioning',
  'withShortenedMetrics',
  'withDoubleClickZoomOut',
  'withMyRuns',
  'withUdfWidget',
  'withNewChart',
] as const;

export type DbPersistedFeatureFlag = (typeof DB_PERSISTED_FEATURE_FLAGS_KEYS)[number];

/**
 * Asserts that all DbPersistedFeatureFlag are also FeatureFlag. TypeScript should fail in the case
 * of an additional field in DB_PERSISTED_FEATURE_FLAGS_KEYS that is missing in featureFlags.
 */
export function toFeatureFlag(input: DbPersistedFeatureFlag): FeatureFlag {
  return input;
}

export type DbPersistedFeatureFlags = Record<DbPersistedFeatureFlag, boolean>;

/*
Feature flags are initialized in the neptune-app/index.js file.
And can be overridden by the API when the DBPersistedConfigStore is initialized in
neptune-app/initialization/desktop.tsx.

If a DBPersistedFeatureFlag is read (using its getter function from common/featureFlag)
before the DBPersistedConfigStore is initialized,
it will throw an error unless it is marked as safe to be read before initialization.

Note: If a DBPersistedFeatureFlag is only read after the DBPersistedConfigStore is initialized,
no need to add it to this list. This list is only for feature flags that are read before the
DBPersistedConfigStore is initialized.
You don't need to manually check/search the code to know if a flag is read before the
DBPersistedConfigStore is initialized, if it happens, you will know through the thrown error
(which includes the feature flag name).
*/
export const DB_PERSISTED_KEYS_SAFE_BEFORE_INITIALIZATION: (keyof DbPersistedFeatureFlags)[] = [];
